import { ReactNode } from 'react';
import { splitLinkifyText } from './linkifySplit';

type Props = {
  children: ReactNode;
};

function linkify(str: string) {
  const parts = splitLinkifyText(str);

  return parts.map((part, key) => {
    if (typeof part === 'string') {
      return part;
    }

    return (
      <a
        className='cursor-pointer text-blue'
        key={key}
        href={part.url}
        target='_blank'
        rel='noreferrer'
      >
        {part.text}
      </a>
    );
  });
}

export function Linkify({ children }: Props) {
  return <>{typeof children === 'string' ? linkify(children) : null}</>;
}
